import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = {
    autohide: { type: Boolean, default: true }
  }

  connect() {
    const toast = new bootstrap.Toast(this.element, {
      autohide: this.autohideValue,
      delay: 5000
    })
    toast.show()

    this.element.addEventListener('hidden.bs.toast', () => {
      this.element.remove()
    })
  }
}
